module.exports = __webpack_public_path__ + "static/Profile-Vanessa_v2-e7166dd97038c6b40c19258fe8f49c37.svg";